export const ID_NUMBER_REGEX = /^\d{9}$/
export const ID_ENTERPRISE_REGEX = /^\d{10}$/
export const DIMEX =  /^((?!(0))[0-9]{11,12})$/
export const NITE = /^\d{10}$/
export const PHONE_NUMBER = /^\d{8}$/
export const PHONE_EXTENSION = /^\d{3}$/
export const IS_NUMBER = /^\d+$/